import React from 'react';
import { checkPassword, sendLoginPayload } from 'account-portal-library/lib/emailSignIn';
import { parseCookies, setCookies, validateSessionToken, isValidGoToURL } from "account-portal-library/lib/helperFunctions";
import AppVars from '../../AppVars.js';
import Logger from '../../Logger.js';

import TOPasswordFormView from '../Views/TO/Login/PasswordFormView';
import PasswordFormMFA from '../Views/TO/Login/PasswordFormMFA';
import { getGotoUrlFromCookies } from '../../gotoUrl.js';
import navigateWithAnalytics from '../../analytics/navigateWithAnalytics.js';
import pushAnalytics from '../../analytics/pushAnalytics.js';

const appVars = AppVars.getInstance()
const logger = Logger.getInstance();

const ACCOUNT_LOCKED_URL = "/accountlocked";
const UNKNOWN_ERROR_URL = "/unknownerror";

const INPUT_TYPES = {
    "PHONE": "^(?!0)[0-9]{10}$",
    "EMAIL": "(^[0-9A-Z_a-z][-0-9A-Z_a-z]*(\\.[-0-9A-Z_a-z]+)*@([0-9A-Z_a-z][-0-9A-Z_a-z]*(\\.[-0-9A-Z_a-z]+)*\\.(AERO|ARPA|BIZ|COM|COOP|EDU|GOV|INFO|INT|LAW|MIL|MOBI|MUSEUM|NAME|NET|ORG|PRO|TRAVEL|aero|arpa|biz|com|coop|edu|gov|info|int|law|mil|mobi|museum|name|net|org|pro|travel|[A-Za-z][A-Za-z])|([0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}))(:[0-9]{1,5})?$)"
}

const COMPONENT_TREE = [
    { component_name: 'LoginPage', component_version: '1.0.0' },
    { component_name: 'PasswordForm', component_version: '1.0.0' }
];

class PasswordForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            displayUsername: this.props.username,
            password: "",
            payload: null,
            loading: false,
            showPassword: false,
            isPasswordValid: null,
            isLoginValid: null,
            onFocus: false,
            floatLabel: true,
            hasStarted: false
        };
        this.handlePasswordChange = this.handlePasswordChange.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.setFocus = this.setFocus.bind(this);
        this.removeFocus = this.removeFocus.bind(this);
        this.hideModalLocked = this.hideModalLocked.bind(this);
        this.hideModalInvalid = this.hideModalInvalid.bind(this);
        this.showHidePassword = this.showHidePassword.bind(this);
        this.onBlur = this.onBlur.bind(this);
        this.saveURI = this.saveURI.bind(this);
        this.handleResetPassword = this.handleResetPassword.bind(this);
        this.updateHasStarted = this.updateHasStarted.bind(this);
    }

    componentDidMount() {
        if (this.props.acr_values !== "MFA" && (this.props.signInType === "PHONE" || this.props.signInType === "OTP")) {
            const username = this.props.username
            const displayPhone = "(" + username.substring(0, 3) + ") " + username.substring(3, 6) + "-" + username.substring(6, 10)
            this.setState({ displayUsername: displayPhone })
        }
    }

    async handleFormSubmit(event) {
        //Prevent default submit button behavior
        event.preventDefault();
        this.setState({ isPasswordValid: null, isLoginValid: null, loading: true })
        //Check that form isn't blank
        const valid = this.validateInput();
        // this.setState({ loading: false })
        window._dL = { ...(window._dL || {}), user_login_source: "Email" };

        if (valid) {
            this.setState({ loading: true })
            let passwordPayload = this.props.payload;
            if (this.state.payload != null) {
                passwordPayload = this.state.payload
            }
            try {
                const url = appVars.getBaseUrl() + "/" + appVars.getName() + '/json' + appVars.getRealm() + '/authenticate';
                const params = {
                    'authIndexType': 'service',
                    'authIndexValue': this.props.acr_values === "MFA" ? appVars.getMFATree() : appVars.getSignInTree()
                };
                const headers = {
                    'Accept-API-Version': 'resource=1.1',
                    'Content-Type': 'application/json',
                    ...(this.props.uid ? { 'x-username': this.props.uid } : {}),
                };

                if (passwordPayload.callbacks.length === 1) {
                    passwordPayload.callbacks[0].input[0].value = this.state.password;
                } else {
                    // console.log("Invalid password payload structure");
                    throw passwordPayload;
                }

                const journeyResponse = await sendLoginPayload(passwordPayload, url, headers, params);
                // console.log("Journey Response(Password Submit) -> ", journeyResponse);
                if (journeyResponse.status !== 200) {
                    throw journeyResponse.response;
                }
                this.handleSuccess(journeyResponse.response);
            } catch (errorResponse) {
                // console.log("Error -> ", errorResponse);
                this.handleFailure(errorResponse);
            }
        }
    }

    checkUsernameType(username) {
        let TYPE = null;
        for (const key in INPUT_TYPES) {
            if (username.match(INPUT_TYPES[key]) && appVars.getIncludeSignIn(key)) {
                TYPE = key;
            }
        }
        return TYPE;
    }

    validateInput() {
        const isPasswordValid = this.validatePassword(this.state.password);
        this.setState(prevState => ({ ...prevState, isPasswordValid }));
        if (!isPasswordValid) {
            pushAnalytics("sys-action", {
                displayed_error_message: 'Please enter a password',
                form_name: "password-form",
                field_name: 'password',
                error_type: 'validation',
                content_section: 'Sign in Password',
                metrics: 'km-form_field_entry-error'
            }, COMPONENT_TREE);
        }
        return isPasswordValid;
    }

    handleLoginResponse(loginResponse) {
        if (this.validateForm(loginResponse.status)) {
            this.handleSuccess(loginResponse);
        } else {
            this.handleFailure(loginResponse);
        }
    }

    //Checks that there is a session cookie on the browser
    async checkToken(journeyResponse) {
        try {
            const tokenId = journeyResponse.tokenId
            if (tokenId != null) {
                const validateResponse = await validateSessionToken(tokenId, appVars.getBaseUrl(), appVars.getName(), appVars.getRealm());
                // console.log("validateResponse (checkToken) -> ", validateResponse)
                return validateResponse.response.valid;
            } else {
                return false;
            }
        }
        catch {
            return false;
        }
    }

    handleFailure(journeyResponse) {
        const failureUrl = journeyResponse.failureUrl
        // Invalid credentials - after 5 unsuccessful password attempts
        if (failureUrl === ACCOUNT_LOCKED_URL) {
            this.setState({ loading: false, isAccountLocked: true });
            pushAnalytics("sys-action", { form_name: "password-form", error_type: 'account-locked', field_name: 'password', content_section: 'Sign in Password', metrics: 'km-form_field_submit-error', displayed_error_message: 'This account is locked for 15 minutes due to multiple failed attempts. Please try again later or contact us for help unlocking your account.' }, COMPONENT_TREE);
        }
        else {
            //this.setState({loading: false})
            navigateWithAnalytics(UNKNOWN_ERROR_URL, "error-redirect", "auto");
        }
    }

    async handleSuccess(journeyResponse) {
        if (journeyResponse.successUrl === "/console") {
            if (this.validateForm(journeyResponse)) {
                this.setState({ loading: true })
                const tokenValid = await this.checkToken(journeyResponse);
                this.setState({ loading: false })
                if (tokenValid) {
                    pushAnalytics('aa-link', { button_action: 'submitPassword', link_text: 'sign in', ctaText: 'SIGN IN', link_trigger: 'aa-link', content_section: 'Sign in Password', initiator: 'user', user_login_source: 'Email' }, COMPONENT_TREE, "Logged In");
                    const gotoUrl = getGotoUrlFromCookies(['T']);
                    // console.log("gototURL after cred -> ", gotoUrl);
                    navigateWithAnalytics(gotoUrl, "cookie-redirect", "auto");
                } else {
                    navigateWithAnalytics(UNKNOWN_ERROR_URL, "error-redirect", "auto");
                }
            } else {
                this.handleFailure(journeyResponse)
            }
        } else if (journeyResponse.callbacks[0].type === "ChoiceCallback" && journeyResponse.callbacks[0].output[0].value === "Save device as trusted?") {
            this.props.savePayload(journeyResponse);
            this.props.saveStep("TRUST");
        } else if (journeyResponse.callbacks[0].type === "TextOutputCallback") {
            if (journeyResponse?.callbacks?.[1]?.type === "TextOutputCallback") {
                this.setState({ payload: journeyResponse, loading: false, isAccountLocked: true });
                pushAnalytics("sys-action", { form_name: "password-form", error_type: 'account-locked', field_name: 'password', content_section: 'Sign in Password', metrics: 'km-form_field_submit-error', displayed_error_message: 'This account is locked for 15 minutes due to multiple failed attempts. Please try again later or contact us for help unlocking your account.', user_login_source: 'Email' }, COMPONENT_TREE);
            } else if (journeyResponse?.callbacks?.[1]?.type === "HiddenValueCallback") {
                this.addFingerPrint(journeyResponse);
            }
        } else if (journeyResponse.callbacks[0].type === "PasswordCallback") {
            this.setState({ payload: journeyResponse, loading: false, isLoginValid: false });
            pushAnalytics("sys-action", { form_name: "password-form", error_type: 'invalid-password', field_name: 'password', content_section: 'Sign in Password', metrics: 'km-form_field_submit-error', displayed_error_message: 'Invalid password. An excessive number of failed attempts will temporarily lock your account.', user_login_source: 'Email' }, COMPONENT_TREE);
        } else {
            navigateWithAnalytics(UNKNOWN_ERROR_URL, "error-redirect", "auto");
        }
    }

    async addFingerPrint(payload) {
        try {
            const url = appVars.getBaseUrl() + '/' + appVars.getName() + '/json' + appVars.getRealm() + '/authenticate';
            const headers = {
                'Accept-API-Version': 'resource=2.0',
                'Content-Type': 'application/json'
            }
            const params = {
                'authIndexType': 'service',
                'authIndexValue': appVars.getMFATree()
            }

            // checking the fingerprint payload
            if (payload.callbacks[1] != null) {
                if (sessionStorage.AP_SSID == null) {
                    // get phone number from password response
                    if (payload.callbacks[0].output[0].value) {
                        const phoneNumber = payload.callbacks[0].output[0].value.split("telephoneNumber\": \"")[1].substring(0, 11);
                        this.props.savePhoneNumber(phoneNumber);
                    }
                }
                // set fingerprint value
                payload.callbacks[1].input[0].value = `{"screen":{"screenWidth":${window.screen.width},"screenHeight":${window.screen.height},"screenColourDepth":${window.screen.colorDepth}},"timezone":{"timezone":"${new Date().getTimezoneOffset()}"},"plugins":{"installedPlugins":"internal-pdf-viewer;internal-pdf-viewer;internal-pdf-viewer;internal-pdf-viewer;internal-pdf-viewer;"},"fonts":{"installedFonts":"cursive;monospace;serif;sans-serif;fantasy;default;Arial;Arial Black;Arial Narrow;Bookman Old Style;Bradley Hand ITC;Century;Century Gothic;Comic Sans MS;Courier;Courier New;Georgia;Impact;Lucida Console;Monotype Corsiva;Papyrus;Tahoma;Times;Times New Roman;Trebuchet MS;Verdana;"},"userAgent":"${navigator.userAgent}","language":"${navigator.language}"}`;
            }
            const fingerPrintResponse = await sendLoginPayload(payload, url, headers, params);
            // console.log("fingerPrintResponse -> ", fingerPrintResponse);
            if (fingerPrintResponse.status !== 200) {
                throw fingerPrintResponse.response;
            }
            this.setState({ loading: false });
            this.props.savePayload(fingerPrintResponse.response);

            if (fingerPrintResponse.response.callbacks) {
                if (fingerPrintResponse.response.callbacks[0].type === 'ChoiceCallback') {
                    this.props.saveStep("TRUST");
                }
                else {
                    this.props.savePhoneNumber(fingerPrintResponse.response.callbacks[1].output[0].value);
                    this.props.saveUsername(fingerPrintResponse.response.callbacks[0].output[0].value);
                    const choiceResponse = await sendLoginPayload(fingerPrintResponse.response, url, headers, params);
                    if (choiceResponse.status !== 200) {
                        throw choiceResponse.response;
                    }
                    this.props.savePayload(choiceResponse.response);
                    const callbacksMapping = { 1: 'SELECT', 3: 'EMAIL_CODE' };
                    this.props.saveStep(callbacksMapping[choiceResponse?.response?.callbacks.length]);
                }
            } else {
                this.setState({ loading: true });
                const tokenValid = await this.checkToken(fingerPrintResponse.response);
                this.setState({ loading: false })
                if (tokenValid) {
                    const gotoUrl = getGotoUrlFromCookies(['T']);
                    navigateWithAnalytics(gotoUrl, "cookie-redirect", "auto");
                } else {
                    navigateWithAnalytics(UNKNOWN_ERROR_URL, "error-redirect", "auto");
                }
            }
        } catch (errorResponse) {
            // console.log("Error -> ", errorResponse);
            this.handleFailure(errorResponse);
        }
    }

    async handleResetPassword() {
        this.setState({ loading: true });
        try {
            const payload = this.state.payload;
            const maskedEmail = payload.callbacks[0].output[0].value;
            const url = appVars.getBaseUrl() + '/' + appVars.getName() + '/json' + appVars.getRealm() + '/authenticate';
            const headers = {
                'Accept-API-Version': 'resource=2.0',
                'Content-Type': 'application/json',
                'x-username': this.props.uid || sessionStorage.AP_SSID
            }
            const params = {
                'authIndexType': 'service',
                'authIndexValue': appVars.getMFATree()
            }
            const resetJourneyResponse = await sendLoginPayload(payload, url, headers, params);
            // console.log("resetJourneyResponse -> ", resetJourneyResponse);
            if (resetJourneyResponse.status !== 200) {
                throw resetJourneyResponse.response;
            }
            this.setState({ payload: resetJourneyResponse.response });
            sessionStorage.setItem("uid", this.props.uid);
            sessionStorage.setItem("EMAIL", maskedEmail);
            sessionStorage.setItem("RP_PAYLOAD", JSON.stringify(resetJourneyResponse.response));

            this.setState({ loading: false });
            navigateWithAnalytics('/reset', "user-redirect", "user");
        } catch (errorResponse) {
            // console.log("Error -> ", errorResponse);
            this.handleFailure(errorResponse);
        }
    }

    validatePassword(password) {
        if (password === undefined || password === null || password.length === 0) {
            return false;
        }
        return true;
    }

    validateForm(status) {
        if (status > 299) {
            return false;
        }
        else {
            return true;
        }
    }

    saveURI() {
        if (this.props.style === "DG") {
            setCookies("login_uri", window.location.href, "/", appVars.getDomain())
        }
        navigateWithAnalytics(UNKNOWN_ERROR_URL, "error-redirect", "auto");
    }

    handlePasswordChange(event) {
        const password = event.target.value;
        this.setState({ password, isPasswordValid: this.validatePassword(event.target.value) })
    }

    setFocus(event) {
        this.setState({ onFocus: true })
        this.setState({ floatLabel: false })
    }

    removeFocus() {
        this.setState({ onFocus: false })
    }

    onBlur() {
        if (this.state.password === "") {
            this.setState({ floatLabel: true })
        } else {
            this.setState({ floatLabel: false })
        }
        this.removeFocus()
        this.setState({ isPasswordValid: this.validatePassword(this.state.password) })
    }

    hideModalLocked() {
        this.setState({ isAccountLocked: null })
    }

    hideModalInvalid() {
        this.setState({ isLoginValid: null })
    }

    showHidePassword() {
        this.setState({ showPassword: !this.state.showPassword })
    }

    updateHasStarted(value) {
        this.setState({ hasStarted: value })
    }

    render() {
        const commonProps = {
            style: this.props.style,
            username: this.props.username,
            displayUsername: this.state.displayUsername,
            password: this.state.password,
            loading: this.state.loading,
            showPassword: this.state.showPassword,
            isPasswordValid: this.state.isPasswordValid,
            isFormValid: this.state.isFormValid,
            isLoginValid: this.state.isLoginValid,
            isAccountLocked: this.state.isAccountLocked,
            handleFormSubmit: this.handleFormSubmit,
            handlePasswordChange: this.handlePasswordChange,
            handleResetPassword: this.handleResetPassword,
            onFocus: this.state.onFocus,
            setFocus: this.setFocus,
            removeFocus: this.removeFocus,
            signInType: this.props.signInType,
            hideModalInvalid: this.hideModalInvalid,
            hideModalLocked: this.hideModalLocked,
            showHidePassword: this.showHidePassword,
            onBlur: this.onBlur,
            floatLabel: this.state.floatLabel,
            saveURI: this.saveURI,
            hasStarted: this.state.hasStarted,
            updateHasStarted: this.updateHasStarted,
        }
        return (this.props.acr_values === "MFA" && (this.props.signInType === "PHONE" || this.props.signInType === "OTP")) ? <PasswordFormMFA {...commonProps} /> : <TOPasswordFormView {...commonProps} />
    }
}

export default PasswordForm;